import React from "react";
import { Trans } from "@lingui/macro";

const ReviewsSection = ({
  isSSR,
  isMobileView,
  overallCount,
  lang,
  attractionId,
  attractionName,
  cityName,
  ClientComponents,
  CustomerReviewsBase,
}) => {
  if (!CustomerReviewsBase && !ClientComponents?.CustomerReviews) {
    return null;
  }

  const ReviewsComponent = isSSR ? CustomerReviewsBase : ClientComponents?.CustomerReviews;

  const props = {
    showOverallRating: true,
    overallCount,
    withPopup: isMobileView,
    lang,
    isMobile: isMobileView,
    queryParams: { attractionId },
    title: <Trans>What people say about {attractionName || cityName}</Trans>,
  };

  return isSSR ? (
    <ReviewsComponent {...props} />
  ) : (
    <React.Suspense fallback={null}>
      <ReviewsComponent {...props} />
    </React.Suspense>
  );
};

export default ReviewsSection;
